import { useMemo } from 'react';
import { useAuth } from '@/presentation/hook/useAuth';
import { hasSubcategoryAccess } from '@/domain/model/accessUtils';

export const useSubcategoryAccess = (subcategoryId: string | undefined) => {
  const { user, isAuthenticated, isAdmin } = useAuth();

  const hasAccess = useMemo(
    () => isAuthenticated && hasSubcategoryAccess(user, isAdmin, subcategoryId),
    [user, isAuthenticated, isAdmin, subcategoryId],
  );

  return { hasAccess, isAuthenticated, user, isAdmin };
};
